import { type BaseNotificationItemProps, NotificationItem } from '../components/NotificationItem'
import { Notification } from '../Notification'

export type TrainingCompleteProps = BaseNotificationItemProps & {
  userName: string
  programName: string
  type: 'training-complete'
}

export function TrainingComplete({ userName, programName, ...props }: TrainingCompleteProps) {
  return (
    <NotificationItem
      {...props}
      avatar={{
        ...props.avatar,
        addon: <Notification.Addon.Avatar size={props.size} color='green' icon='check' />,
      }}
      title={`${userName} Training Complete`}
      subTitle={programName}
      descriptionAddon={
        <p className='flex text-sm text-gray-500'>{userName} is now eligible to work for this program.</p>
      }
    />
  )
}
